import React from 'react';
import type { GetStaticPaths } from 'next';
import { CollectionsIndex, collectionsSsrLogic } from '@components/pages/collections';
import { CollectionDetails, collectionDetailsSsrLogic } from '@components/pages/collections/details';
import { Default as DefaultLayout } from '@components/templates/layouts/Default';
import { decodeOptions } from '@src/utils/urlHelpers';

export const Collections = ({ data, slug }) => {
  if (slug === 'index') {
    return <CollectionsIndex data={data} />;
  }
  return <CollectionDetails data={data} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: ['/collections/index'],
    fallback: 'blocking',
  };
};
export const getStaticProps = async ({ params }) => {
  const options = decodeOptions(params?.slug);

  if (options.slug === 'index') {
    const result = await collectionsSsrLogic();
    return result;
  }

  const result = await collectionDetailsSsrLogic({ slug: options.slug });
  return result;
};

Collections.PageLayout = DefaultLayout;

export default Collections;
